import { useClientState } from "./useClientState.js";
import { isMobile } from "../isMobile.js";
export function useIsMobile() {
  return useClientState(isMobile, false);
}